// FPOMarkCertification.jsx
import React from "react";

export default function FPOMarkCertification() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            FPO Mark Certification
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            FPO Mark Certification for Fruit Product Processors
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists agricultural producers in obtaining FPO
            Mark Certification for quality assurance of processed fruit products
            including juices, jams, pickles, and canned goods.
          </p>
          <p className="text-gray-700">
            From FSSAI license integration and product testing coordination to
            facility inspection preparation and certification approval, the
            process ensures compliance with mandatory fruit processing standards.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1099680/pexels-photo-1099680.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Fruit processing unit for FPO Mark certification"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for FPO Mark Certification
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile documentation integrating FSSAI
              licensing requirements with FPO quality standards for fruit
              processors.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Business registration details (GST, incorporation certificate, or partnership deed).</li>
                <li>
                  Product specifications including formulations, ingredient
                  lists, processing methods, and quality control parameters.
                </li>
                <li>
                  Premises address proof with manufacturing facility layout,
                  hygiene protocols, and FSSAI inspection readiness documents.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm provides specialized FPO support with expertise in fruit
              processing standards and FSSAI certification integration.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Agricultural Compliance Expertise
                </h3>
                <p className="text-gray-700 text-sm">
                  Deep knowledge of Fruit Products Order standards, FSSAI fruit
                  processing regulations, and mandatory quality certification
                  requirements for agricultural processors.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Quality Certification Support
                </h3>
                <p className="text-gray-700 text-sm">
                  Complete assistance with product testing, facility inspection
                  preparation, laboratory analysis coordination, and FPO mark
                  approval process.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Professional Service Delivery
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end handling from application through FSSAI audit,
                  product certification, and label compliance to ensure legal
                  market readiness for processed fruit products.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
